import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-[#172C22] text-[#E4ECE7] pt-16 pb-12 border-t border-[#264435]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-[#2A4B3A]">
          
          {/* Brand & Mission */}
          <div className="space-y-4">
            <div className="brand-wordmark text-2xl font-bold text-white tracking-tight">
              Elses skrub og skur
            </div>
            <p className="text-sm text-[#B4C8BD] leading-relaxed">
              Lokal, grundig og pålidelig rengøringsservice til private boliger og erhvervsvirksomheder i Skjern og lokalområdet.
            </p>
            <div className="inline-flex items-center gap-2 text-xs font-semibold text-[#8EB09C] bg-[#223E30] px-3 py-1.5 rounded-full border border-[#2E5240]">
              <i className="fa-solid fa-location-dot text-[#70A584]" aria-hidden="true"></i>
              <span>Lokal forankring i Skjern</span>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-[#B4C8BD] hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/privat-rengoering" className="text-[#B4C8BD] hover:text-white transition-colors">
                  Privat rengøring
                </Link>
              </li>
              <li>
                <Link to="/erhvervsrengoering" className="text-[#B4C8BD] hover:text-white transition-colors">
                  Erhvervsrengøring
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-[#B4C8BD] hover:text-white transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Services Quick Overview */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm text-[#B4C8BD]">
              <li className="flex items-center gap-2">
                <i className="fa-regular fa-check text-[#70A584]" aria-hidden="true"></i>
                <span>Fast rengøringsaftale</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-regular fa-check text-[#70A584]" aria-hidden="true"></i>
                <span>Hovedrengøring &amp; privat</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-regular fa-check text-[#70A584]" aria-hidden="true"></i>
                <span>Kontorrengøring &amp; erhverv</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="fa-regular fa-check text-[#70A584]" aria-hidden="true"></i>
                <span>Lokal og personlig betjening</span>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-sm font-bold uppercase tracking-wider text-white">
              Kontaktoplysninger
            </h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-3">
                <i className="fa-regular fa-location-dot mt-1 text-[#70A584]" aria-hidden="true"></i>
                <div className="text-[#B4C8BD]">
                  <p className="font-semibold text-white">Elses skrub og skur</p>
                  <p>Vardevej 58</p>
                  <p>6900 Skjern</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-[#70A584]" aria-hidden="true"></i>
                <a
                  href="tel:52506794"
                  className="contact-no-break text-[#B4C8BD] hover:text-white transition-colors font-medium"
                >
                  52 50 67 94
                </a>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-[#70A584]" aria-hidden="true"></i>
                <a
                  href="mailto:else_christiansen@godmail.dk"
                  className="contact-no-break text-[#B4C8BD] hover:text-white transition-colors font-medium"
                >
                  else_christiansen@godmail.dk
                </a>
              </div>

              <div className="pt-2 text-xs text-[#8EB09C]">
                CVR: <span className="contact-no-break font-mono text-[#D2E0D6]">41795638</span>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#8EB09C]">
          <p>© {new Date().getFullYear()} Elses skrub og skur. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-2">
            <span>Lokal rengøringsservice i Skjern</span>
            <span>•</span>
            <Link to="/kontakt" className="hover:text-white transition-colors underline underline-offset-4">
              Kontakt mig
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}
